import { LoginScreen } from '@/components/chrome/LoginScreen';

export function LoginPage() {
  return <LoginScreen />;
}
